const initialState={	
	juegos:[],
	estadoJuego:0,
	juegoSelected:{nombre:"",Consolas:"",poster:"",videopresentacion:"",multiplayerOffLine:"",multiplayerOnLine:"",peso:"",audio:"",
					subtitulos:"",descripcion:"",Categoria:[]}
};


export default function juegoReducer(state= initialState,action){
	switch(action.type){

		case 'JUEGOS':
     		return {...state,juegos:action.payload};
     	case 'JUEGO_SELECTED':
     		return {...state,juegoSelected:action.payload};
     	case 'ESTADO_JUEGO':
     		return {...state,estadoJuego:action.payload};    	
     	case 'NEW_JUEGO':
     		return { ...state, juegoSelected: { ...state.juegoSelected, ...action.payload } };
     	default:
     		return state
	}
}